import { render, staticRenderFns } from "./DashboardFinance.vue?vue&type=template&id=05ecf047&"
import script from "./DashboardFinance.vue?vue&type=script&lang=js&"
export * from "./DashboardFinance.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFinance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports